<template>
  <div class="ma-0 pa-0 card_container">
    <v-card>
      <v-card-title
        style="background-color: #82a1d0; position: sticky; top: 0; z-index: 3"
        background-color="primary"
        class="d-flex align-center"
      >
        <div>
          <v-dialog
            class="blue"
            v-model="btnConfigColumns.menu"
            max-width="400px"
            @keydown.esc="toggleColumnMenu"
            offset-x
          >
            <template v-slot:activator="{ on, attrs }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="white"
                    dark
                    icon
                    @click="toggleColumnMenu"
                    v-bind="attrs"
                    v-on="on"
                    class="mr-5"
                  >
                    <v-icon>{{ btnConfigColumns.icon }}</v-icon>
                  </v-btn>
                </template>
                <span>{{ btnConfigColumns.tooltip }}</span>
              </v-tooltip>
            </template>
            <v-card>
              <div class="d-flex align-center">
                <v-text-field
                  v-model="columnFilter"
                  placeholder="Buscar columnas"
                  outlined
                  dense
                  hide-details
                  class="pt-2 pl-2 pb-0 ma-0 flex-grow-1"
                ></v-text-field>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      class="pt-2 ma-0 pb-0 hover-effect"
                      v-bind="attrs"
                      v-on="on"
                      @click="resetColumnsOrder"
                    >
                      <v-icon size="27" class="hover-icon">mdi-restore</v-icon>
                    </v-btn>
                  </template>
                  <span>Restablecer orden</span>
                </v-tooltip>
              </div>
              <div
                style="
                  min-width: 250px;
                  max-height: 250px;
                  overflow-y: scroll;
                  scrollbar-width: unset;
                "
                class="pa-2 pb-0 ma-0"
                hide-details
              >
                <div
                  v-if="filteredColumns?.length === 0"
                  class="text-center px-2 pb-2"
                >
                  <span>No hay resultados que coincidan con la búsqueda</span>
                </div>
                <div v-else>
                  <div
                    v-for="(column, index) in visibleHeaders"
                    :key="column.field"
                    draggable="true"
                    @dragstart="dragStart(index)"
                    @dragover.prevent
                    @drop="drop(index)"
                    class="d-flex align-center draggable-item"
                  >
                    <v-icon class="mr-2">mdi-drag</v-icon>
                    <v-checkbox
                      v-model="column.visible"
                      :label="column.text"
                      hide-details
                      class="my-auto mb-2"
                    ></v-checkbox>
                  </div>
                </div>
              </div>
              <v-card-actions class="d-flex justify-space-between">
                <v-btn class="bt-exit" @click="toggleColumnMenu">
                  <v-icon>fas fa-times</v-icon>
                </v-btn>
                <v-btn
                  color="bt-acept"
                  @click="
                    saveConfigColumns();
                    toggleColumnMenu();
                  "
                >
                  <v-icon>fas fa-save</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
        <v-text-field
          dense
          solo
          v-model="search"
          append-icon="mdi-magnify"
          :label="$tc('commons.search')"
          single-line
          hide-details
          class="search"
        />
      </v-card-title>

      <v-data-table
        :no-data-text="$tc('gestionTiempos.notEmployees')"
        :single-select="sigleSelect"
        show-select
        :headers="visibleHeaders"
        :items="indexedItems"
        :search="search"
        show-expand
        fixed-header
        class="mt-1"
        item-key="id"
        v-model="selecLocal"
        :key="tableKey"
        :height="tableHeight"
        :options.sync="tableOptions"
        :footer-props="{
          itemsPerPageOptions: [
            { text: '20', value: 20 },
            { text: '100', value: 100 },
            { text: 'Todos', value: -1 },
          ],
        }"
      >
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" class="td-sub">
            <table style="width: 100%" class="table">
              <tr>
                <th class="th-sub-ano">
                  {{ $tc("newController.absences") }}
                </th>
                <th class="th-sub-avisos">{{ $tc("newController.lates") }}</th>
                <th class="th-sub-avisos">{{ $tc("newController.falls") }}</th>
                <th class="th-sub-avisos">{{ $tc("newController.ret") }}</th>
                <th class="th-sub-avisos">{{ $tc("newController.inc") }}</th>
                <th class="th-sub-normals">{{ $tc("newController.liD") }}</th>
                <th class="th-sub-normals">Lic.Horas</th>
                <th class="th-sub-extras">{{ $tc("newController.extras") }}</th>
              </tr>
              <tr>
                <td>
                  <span v-if="item.aus == true">🔴</span>
                  <span v-else> </span>
                </td>
                <td>
                  <span v-if="item.tar == true">🟡</span>
                  <span v-else> </span>
                </td>
                <td>
                  <span v-if="item.hca == true">🟡</span>
                  <span v-else> </span>
                </td>
                <td>
                  <span v-if="item.ret == true">🟡</span>
                  <span v-else> </span>
                </td>
                <td>
                  <span v-if="item.inc == true">🟡</span>
                  <span v-else> </span>
                </td>
                <td>
                  <span v-if="item.liD == true">🔵</span>
                  <span v-else> </span>
                </td>
                <td>
                  <span v-if="item.liH == true">🔵</span>
                  <span v-else> </span>
                </td>
                <td>
                  <span v-if="item.ext == true">🟢</span>
                  <span v-else> </span>
                </td>
              </tr>
            </table>
          </td>
        </template>
        <template v-slot:[`item.firma`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">
                <div class="center">
                  <v-checkbox @click="enabled(item)" v-model="item.enabled">
                  </v-checkbox>
                </div>
              </span>
            </template>
            <span>{{ $tc("assigNovelty.title") }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.pendingStatus`]="{ item }">
          <v-icon
            color="error"
            dark
            @click="pendingNovelty(item)"
            small
            v-if="item.pendingStatus === 1"
          >
            fa-bell
          </v-icon>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <div class="text-center">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <v-icon color="primary" dark @click="openActions(item)" small>
                    fa-plus
                  </v-icon>
                </span>
              </template>

              <v-list class="v-list__">
                <v-list-item-group v-model="selectedItem" color="primary">
                  <v-list-item
                    v-for="(action, index) in actions"
                    :key="action.id"
                    @click="switchActions(index)"
                    style="cursor: pointer"
                    color="primary"
                    class="itemhover"
                    :disabled="!can(action.code)"
                  >
                    <v-list-item-icon>
                      <v-icon
                        small
                        class="hovericon"
                        :disabled="!can(action.code)"
                        >{{ action.icon }}</v-icon
                      >
                    </v-list-item-icon>
                    <v-list-item-title>{{ action.text }} </v-list-item-title>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-menu>
          </div>
        </template>
      </v-data-table>
      <v-dialog
        v-model="dialogShow"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
        :retain-focus="false"
        @keydown.esc="closeDialog()"
        persistent
      >
        <v-card tile class="v-card-dialog">
          <v-toolbar flat dark color="primary toolbar__buttons">
            <div
              v-if="showRegistration"
              class="border ma-0 ml-4 d-flex justify-start"
              style="width: fit-content"
            >
              <v-tooltip
                v-for="(item, index) in actionsButtonPanel"
                :key="item.id"
                bottom
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    @click="switchActions(index + 1), openActions()"
                    small
                    class="btn-table ma-1"
                    :disabled="!can(item.code)"
                  >
                    <v-icon small color="white">{{ item.icon }}</v-icon>
                  </v-btn>
                </template>
                <span>{{ item.text }}</span>
              </v-tooltip>
            </div>
            <v-spacer />
            <div class="d-flex justify-end">
              <v-btn
                color="white"
                text
                class="mr-5 btn"
                @click="previous()"
                v-if="showRegistration"
                :disabled="disabledPrevious"
              >
                <v-img
                  src="../../assets/icons/anterior-osc.png"
                  style="cursor: pointer"
                  alt="anterior"
                  max-width="30"
                  max-height="30"
                  dark
                />{{ $tc("gestionEmpleados.previous") }}
              </v-btn>
              <v-btn
                color="white"
                text
                @click="next()"
                v-if="showRegistration"
                :disabled="disabledNext"
                >{{ $tc("gestionEmpleados.next") }}
                <v-img
                  src="../../assets/icons/siguiente-osc.png"
                  style="cursor: pointer"
                  alt="siguiente"
                  max-width="30"
                  max-height="30"
                  dark
                />
              </v-btn>

              <v-btn @click="closeDialog" color="white" text class="ml-2"
                >{{ $tc("newController.close") }}
                <v-img
                  src="../../assets/icons/egreso-osc.png"
                  style="cursor: pointer"
                  alt="siguiente"
                  max-width="30"
                  max-height="30"
                  dark
                />
              </v-btn>
            </div>
          </v-toolbar>

          <div v-if="showContainer">
            <Information
              v-if="showInfo"
              :dialog="dialogShow"
              :items="itemActions"
              @close="closeDialog"
            />
            <DetailsOfTheDay
              v-if="showRegistration"
              :dialog="dialogShow"
              @close="closeDialog"
              :items="itemActions"
              :loading="loading"
            />
            <Autoriz
              v-if="showAuthorize"
              :dialog="dialogShow"
              :items="itemActions"
              @close="closeDialog"
            />
            <ChangeSchedule
              :refreshForm="counter"
              v-if="showShedule"
              :dialog="dialogShow"
              :items="itemActions"
              @close="closeDialog"
            />
            <ChangeGroup
              v-if="showGroup"
              :dialog="dialogShow"
              :items="itemActions"
              :refreshForm="counter"
              @close="closeDialog"
            />
            <ChangeTimePattern
              v-if="showTimeSchedule"
              :dialog="dialogShow"
              :items="itemActions"
              :refreshForm="counter"
              @close="closeDialog"
            />
            <ChangeSettlementModel
              v-if="showChangeSettlement"
              :refreshForm="counter"
              :dialog="dialogShow"
              :items="itemActions"
              @close="closeDialog"
            />
            <AssignCards
              v-if="showAssignCard"
              :dialog="dialogShow"
              :items="itemActions"
              :refreshForm="counter"
              @close="closeDialog"
            />
            <AccessControl
              v-if="showAccessControl"
              :dialog="dialogShow"
              :items="itemActions"
              :refreshForm="counter"
              @close="closeDialog"
            />
          </div>
        </v-card>
      </v-dialog>
    </v-card>

    <v-snackbar v-model="notItems" color="#FF8D58" rounded="pill">
      {{ $tc("newController.notItems") }}
      <template v-slot:action="{ attrs }">
        <v-btn color="black" text v-bind="attrs" @click="notItems = false">
          {{ $tc("newController.close") }}
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog
      v-model="showProgressOverlay"
      class="dialog__loader"
      :overlay-opacity="0.3"
    >
      <Loader :loading="showProgressOverlay" />
    </v-dialog>
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </div>
</template>

<script>
import permissions from "../mixins/permissions";
import resultSettlementHours from "../../store/gestionTiempos/resultSettlementHours";
import DetailsOfTheDay from "../GestionTiempos/Actions/DetalleDelDia/DetalleDelDia.vue";
import registrations from "../../store/gestionTiempos/registrations";
import Autoriz from "./Actions/Autoriz";
import autoriz from "../../store/gestionTiempos/autoriz";
import Information from "./Actions/LiquidationOfHours.vue";
import ChangeSchedule from "./Actions/ChangeSchedule.vue";
import ChangeGroup from "./Actions/ChangeGroup.vue";
import ChangeTimePattern from "./Actions/ChangeTimePattern.vue";
import changeTimePattern from "../../store/gestionTiempos/changeTimePattern";
import ChangeSettlementModel from "./Actions/ChangeSettlementModel.vue";
import AssignCards from "./Actions/AssignCards";
import AccessControl from "./Actions/AccessControl.vue";
import accessControl from "../../store/gestionTiempos/accessControl";
import Loader from "../Complement/Loader.vue";
import configTable from "@/store/configuracionDeTablas/configTable.js";
import Snackbar from "@/components/Complement/Snackbar.vue";

export default {
  components: {
    DetailsOfTheDay,
    Autoriz,
    Information,
    ChangeSchedule,
    ChangeGroup,
    ChangeTimePattern,
    ChangeSettlementModel,
    AssignCards,
    Snackbar,
    AccessControl,
    Loader,
  },
  mixins: [permissions],
  props: {
    searchInfo: {
      type: String,
    },
    selec: {
      type: Array,
      event: "listchange",
    },
    viewRegis: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      title: "Gestion Tiempos",
      showProgressOverlay: false,
      showContainer: true,
      loading: true,
      selectedItem: null,
      selectedRow: null,
      selectedItemsNovelty: [],
      sigleSelect: false,
      counter: 0,
      disabledNext: false,
      disabledPrevious: false,
      showActions: false,
      showInfo: false,
      showRegistration: false,
      showAuthorize: false,
      showShedule: false,
      showGroup: false,
      showTimeSchedule: false,
      showChangeSettlement: false,
      showAssignCard: false,
      showAccessControl: false,
      tableKey: 0,
      actionsButtonPanel: [
        {
          id: "authorize-hours",
          text: this.$tc("newController.authorizeHours"),
          icon: "fa-user-shield",
          code: "accion:autorizarhoras",
        },
        {
          id: "change-schedule",
          text: this.$tc("newController.changeSchedule"),
          icon: "fa-clock",
          code: "accion:cambiarhorario",
        },
        {
          id: "change-group",
          text: this.$tc("newController.changeGroup"),
          icon: "fa-users",
          code: "accion:cambiargrupo",
        },
        {
          id: "change-time-schedule",
          text: this.$tc("newController.changeTimeSchedule"),
          icon: "fa-business-time",
          code: "accion:cambiarpautas",
        },
        {
          id: "change-settlement-model",
          text: this.$tc("newController.changeSettlementModel"),
          icon: "fa-cash-register",
          code: "accion:cambiarmodelo",
        },
        {
          id: "liquidation",
          text: this.$tc("newController.liq"),
          icon: "fa-chart-pie",
          code: "accion:cambiarliquidacion",
        },
        {
          id: "assign-card",
          text: this.$tc("newController.assignCard"),
          icon: "fa-id-card",
          code: "accion:asignartarjeta",
        },
        {
          id: "access-control",
          text: this.$tc("newController.accessControl"),
          icon: "fa-fingerprint",
          code: "accion:controlaccesos",
        },
      ],
      actions: [
        {
          id: "edit-registers",
          text: this.$tc("newController.editRegisters"),
          icon: "fa-pen",
          code: "accion:editarregis",
        },
        {
          id: "authorize-hours",
          text: this.$tc("newController.authorizeHours"),
          icon: "fa-user-shield",
          code: "accion:autorizarhoras",
        },
        {
          id: "change-schedule",
          text: this.$tc("newController.changeSchedule"),
          icon: "fa-clock",
          code: "accion:cambiarhorario",
        },
        {
          id: "change-group",
          text: this.$tc("newController.changeGroup"),
          icon: "fa-users",
          code: "accion:cambiargrupo",
        },
        {
          id: "change-time-schedule",
          text: this.$tc("newController.changeTimeSchedule"),
          icon: "fa-business-time",
          code: "accion:cambiarpautas",
        },
        {
          id: "change-settlement-model",
          text: this.$tc("newController.changeSettlementModel"),
          icon: "fa-cash-register",
          code: "accion:cambiarmodelo",
        },
        {
          id: "liquidation",
          text: this.$tc("newController.liq"),
          icon: "fa-chart-pie",
          code: "accion:cambiarliquidacion",
        },
        {
          id: "assign-card",
          text: this.$tc("newController.assignCard"),
          icon: "fa-id-card",
          code: "accion:asignartarjeta",
        },
        {
          id: "access-control",
          text: this.$tc("newController.accessControl"),
          icon: "fa-fingerprint",
          code: "accion:controlaccesos",
        },
      ],
      expanded: [],
      singleExpand: true,
      headers: [
        {
          text: "Empleado",
          value: "company",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Legajo",
          value: "file",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Fecha",
          value: "date",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Día",
          value: "day",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Grupo",
          value: "group",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Anomalias",
          value: "anomalies",
          class: "primary secondary--text",
          visible: true,
        },

        {
          text: "Avisos",
          value: "advertisement",
          class: "primary secondary--text",
          visible: true,
        },

        {
          text: "Normales",
          value: "normals",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Excedentes",
          value: "extras",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Horas Lab.",
          value: "lab",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Horas Trab.",
          value: "trab",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Ultima Firma",
          value: "firm",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Pendiente",
          value: "pendingStatus",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          visible: true,
          width: "80px",
        },
      ],
      buscar: "",
      itemActions: null,
      notItems: false,
      date: null,
      flag: false,
      newItemRefresh: {},
      newArrayRefresh: [],
      btnConfigColumns: {
        menu: false,
        icon: "mdi-cog",
        tooltip: "Columnas",
      },
      columnFilter: "",
      search: "",
      tableHeight: this.calculateMaxHeight(),
      alert: false,
      textAlert: "",
      color: "",
      tableOptions: {
        page: 1,
        itemsPerPage: 20,
        sortBy: [],
        sortDesc: [],
      },
      isSettingAllItems: false,
      detailDays: false,
    };
  },

  computed: {
    allHeaders() {
      return Array.isArray(configTable.state?.colums)
        ? configTable.state.colums
        : [];
    },
    indexedItems() {
      return this.$store.state.gestionTiempos.novedades.map((item, index) => ({
        id: index,
        ...item,
        pendingStatus: item.noveltyEarring ? 1 : 0,
      }));
    },
    dialogShow: {
      get: function () {
        return registrations.state.dialogShow;
      },
      set: function (newValue) {
        //
      },
    },
    selecLocal: {
      get() {
        return this.$store.state.gestionTiempos.deselectItems;
      },
      set(value) {
        this.$store.commit("gestionTiempos/setDeselectItems", value);
        return value;
      },
    },
    filteredItems() {
      const filtered = this.search
        ? this.items.filter((item) =>
            item.name.toLowerCase().includes(this.search.toLowerCase()),
          )
        : this.items;
      if (this.showPagination && this.itemsPerPage) {
        const start = (this.currentPage - 1) * this.itemsPerPage;
        return filtered.slice(start, start + this.itemsPerPage);
      }
      return filtered;
    },
    filteredColumns() {
      const filterText = this.columnFilter.toLowerCase();
      return this.allHeaders?.filter((column) => {
        return column.text.toLowerCase()?.includes(filterText);
      });
    },
    visibleHeaders() {
      return this.allHeaders.filter((column) => column.visible);
    },
  },
  mounted() {
    this.$store.state.gestionTiempos.novedades = [];
    configTable.commit("setColums", []);
    let nameTable = this.title;
    configTable
      .dispatch("getColumsTableName", nameTable)
      .then(() => {
        if (
          configTable.state.colums.length === 0 ||
          configTable.state.colums.length !== this.headers.length
        ) {
          this.saveConfigColumns();
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });
  },
  watch: {
    "tableOptions.itemsPerPage"(newVal, oldVal) {
      // Evitá el loop si ya lo estás seteando vos
      if (this.isSettingAllItems) {
        this.isSettingAllItems = false;
        return;
      }

      if (newVal === -1 && oldVal !== -1) {
        this.showProgressOverlay = true;

        // Cancelás el cambio momentáneamente
        this.tableOptions.itemsPerPage = oldVal;

        this.$nextTick(() => {
          setTimeout(() => {
            this.isSettingAllItems = true;
            this.tableOptions.itemsPerPage = -1;

            // Spinner se apaga luego del render masivo
            setTimeout(() => {
              this.showProgressOverlay = false;
            }, 300);
          }, 50);
        });
      }
    },
  },
  methods: {
    formatDateIso(dateString) {
      if (!dateString) return "";
      const [day, month, year] = dateString.split("-");
      return `${year}-${month}-${day}`;
    },
    resetColumnsOrder() {
      configTable.state.colums = [...this.headers];
      this.saveConfigColumns();
    },
    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;
      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    dragStart(index) {
      this.draggedIndex = index;
    },
    drop(targetIndex) {
      if (this.draggedIndex === null || this.draggedIndex === targetIndex) {
        console.log(
          "⚠️ Drop cancelado (índices iguales o `draggedIndex` es `null`)",
        );
        return;
      }
      // Hacemos una copia del array para manipularlo
      const updatedHeaders = [...configTable.state.colums];
      const [movedItem] = updatedHeaders.splice(this.draggedIndex, 1);

      updatedHeaders.splice(targetIndex, 0, movedItem);

      // Asignamos el nuevo orden
      configTable.state.colums = updatedHeaders;

      // Resetear estado
      this.draggedIndex = null;
    },
    calculateMaxHeight() {
      const windowHeight = window.innerHeight;
      // Define multipliers for different window height ranges
      const lowMultiplier = 0.55; // Multiplier for window heights less than 1000 pixels
      const highMultiplier = 0.65; // Multiplier for window heights 1000 pixels or greater

      // Determine multiplier based on window height
      let multiplier = lowMultiplier;
      if (windowHeight >= 700) {
        multiplier = highMultiplier;
      }

      // Calculate maximum height based on multiplier
      const maxHeight = windowHeight * multiplier;
      return maxHeight;
    },
    updateTableHeight() {
      this.tableHeight = this.calculateMaxHeight();
    },
    handleColumnReorder(newIndex, oldIndex) {
      // Obtenemos todas las cabeceras desde la propiedad computada
      const allHeaders = [...this.allHeaders];

      // Ajustar los índices para tener en cuenta los elementos adicionales de la tabla
      const adjustedOldIndex = oldIndex - 2; // Ajustar según el número de elementos adicionales
      const adjustedNewIndex = newIndex - 2; // Ajustar según el número de elementos adicionales

      // Validar que los índices ajustados estén dentro del rango de cabeceras visibles
      if (
        adjustedOldIndex < 0 ||
        adjustedOldIndex >= allHeaders.length ||
        adjustedNewIndex < 0 ||
        adjustedNewIndex >= allHeaders.length
      ) {
        console.warn(
          "Índices ajustados fuera de rango:",
          adjustedOldIndex,
          adjustedNewIndex,
        );
        return;
      }

      // Extraemos las cabeceras visibles
      const visibleHeaders = allHeaders.filter((header) => header.visible);

      // Reordenamos solo las cabeceras visibles
      const movedHeader = visibleHeaders.splice(adjustedOldIndex, 1)[0];
      visibleHeaders.splice(adjustedNewIndex, 0, movedHeader);

      // Creamos una nueva lista de cabeceras donde las cabeceras visibles reordenadas reemplazan a las originales
      let visibleIndex = 0;
      const newHeaders = allHeaders.map((header) => {
        if (header.visible) {
          return visibleHeaders[visibleIndex++];
        }
        return header;
      });

      // Actualizamos las cabeceras en el estado global
      configTable.state.colums = newHeaders;

      // Incrementamos la clave de la tabla para forzar la actualización
      this.tableKey++;
    },

    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (
        columnsToSave === undefined ||
        this.allHeaders.length !== this.headers.length ||
        columnsToSave.length === 0
      ) {
        columnsToSave = this.headers;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.title,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        this.showAlert(this.$tc("commons.savedColumnSetting"), "#82A1D0");
        configTable.commit("setNew", []);
      });
    },
    toggleColumnMenu() {
      this.btnConfigColumns.menu = !this.btnConfigColumns.menu;
    },
    async switchActions(i) {
      this.showProgressOverlay = true;

      switch (i) {
        case 0:
          this.$store.commit("changeSchedule/setItemStateDay", {
            empId: this.itemActions.empId,
            date: this.formatDateIso(this.itemActions.date),
          });
          this.$store.dispatch("changeSchedule/getStateDay");

          this.detailDays = true;
          this.showRegistration = true;
          this.showAuthorize = false;
          this.showShedule = false;
          this.showGroup = false;
          this.showTimeSchedule = false;
          this.showChangeSettlement = false;
          this.showInfo = false;
          this.showAssignCard = false;
          this.showAccessControl = false;
          this.dispatechersCommons();
          registrations.commit("setDate", this.date);
          break;
        case 1:
          this.showAuthorize = true;
          this.showRegistration = false;
          this.showShedule = false;
          this.showGroup = false;
          this.showTimeSchedule = false;
          this.showChangeSettlement = false;
          this.showInfo = false;
          this.showAssignCard = false;
          this.showAccessControl = false;
          autoriz.commit("setDate", this.date);
          this.dispatechersCommons();
          await autoriz.dispatch("getAutoriz");
          break;
        case 2:
          this.showShedule = true;
          this.showRegistration = false;
          this.showAuthorize = false;
          this.showGroup = false;
          this.showTimeSchedule = false;
          this.showChangeSettlement = false;
          this.showInfo = false;
          this.showAssignCard = false;
          this.showAccessControl = false;
          this.$store.commit("changeGroup/setDate", this.date);
          this.dispatechersCommons();
          await this.$store.dispatch("changeSchedule/getSchedules");
          this.$store.dispatch("changeSchedule/getEmployedSchedule");
          this.$store.dispatch("changeSchedule/getGroupSchedule");
          break;
        case 3:
          this.showGroup = true;
          this.showRegistration = false;
          this.showAuthorize = false;
          this.showShedule = false;
          this.showTimeSchedule = false;
          this.showChangeSettlement = false;
          this.showInfo = false;
          this.showAssignCard = false;
          this.showAccessControl = false;
          this.$store.commit("changeGroup/setDate", this.date);
          this.dispatechersCommons();
          this.$store.dispatch("changeGroup/getGroupsAssigned");
          await this.$store.dispatch("changeGroup/getGroups");
          break;
        case 4:
          this.showTimeSchedule = true;
          this.showRegistration = false;
          this.showAuthorize = false;
          this.showShedule = false;
          this.showGroup = false;
          this.showChangeSettlement = false;
          this.showInfo = false;
          this.showAssignCard = false;
          this.showAccessControl = false;
          changeTimePattern.commit("setDate", this.date);
          this.dispatechersCommons();
          changeTimePattern.dispatch("getTimePattern");
          await registrations.dispatch("getCsCost");
          break;

        case 5:
          this.showChangeSettlement = true;
          this.showRegistration = false;
          this.showAuthorize = false;
          this.showShedule = false;
          this.showGroup = false;
          this.showTimeSchedule = false;
          this.showInfo = false;
          this.showAssignCard = false;
          this.showAccessControl = false;
          this.$store.commit("changeSettlementModel/setDate", this.date);
          this.dispatechersCommons();
          await this.$store.dispatch("gestionTiempos/getModels");
          this.$store.dispatch("changeSettlementModel/getModelEmployed");
          this.$store.dispatch("changeSettlementModel/getModelGroup");
          break;

        case 6:
          this.showInfo = true;
          this.showRegistration = false;
          this.showAuthorize = false;
          this.showShedule = false;
          this.showGroup = false;
          this.showTimeSchedule = false;
          this.showChangeSettlement = false;
          this.showAssignCard = false;
          this.showAccessControl = false;
          this.dispatechersCommons();
          break;
        case 7:
          this.showAssignCard = true;
          this.showRegistration = false;
          this.showAuthorize = false;
          this.showShedule = false;
          this.showGroup = false;
          this.showTimeSchedule = false;
          this.showChangeSettlement = false;
          this.showAccessControl = false;
          this.showInfo = false;
          this.dispatechersCommons();
          await this.$store.dispatch("assignCards/getCards");

          break;
        case 8:
          this.showAccessControl = true;
          this.showRegistration = false;
          this.showAuthorize = false;
          this.showShedule = false;
          this.showGroup = false;
          this.showTimeSchedule = false;
          this.showChangeSettlement = false;
          this.showAssignCard = false;
          this.showInfo = false;
          let payload = {
            date: this.itemActions.date
              .slice(0, 10)
              .split(/\D/)
              .reverse()
              .join("-"),
            endDay: this.itemActions.endDay.slice(0, 10),
            startDay: this.itemActions.startDay.slice(0, 10),
          };
          this.dispatechersCommons();
          accessControl.commit("setAccessControl", payload);
          await accessControl.dispatch("getAccessControl");
          break;

        default:
          break;
      }
      setTimeout(() => {
        registrations.commit("setDialogShow", true);
        this.showProgressOverlay = false;
      }, 500);
    },
    //Procesa la novedad
    pendingNovelty(item) {
      this.showProgressOverlay = true;
      let payload = {
        empId: item.empId,
        date: item.dateNotFormat,
      };

      this.$store.commit("gestionTiempos/setProcessNovelty", payload);
      this.$store.dispatch("gestionTiempos/processNovelty").then(() => {
        this.newFilterForRefresh(payload.empId, payload.date);

        this.showProgressOverlay = false;
      });
      this.$store.commit(
        "gestionTiempos/setDateForRefresh",
        item.dateNotFormat,
      );
    },
    //se hace el dispatch del procesamiento de la novedad procesada
    newFilterForRefresh(empid, date) {
      let filter = {
        Estado: {
          Anomalias: true,
          Normales: {
            Valor: true,
            Detalle: { DiasLiH: true, DiasLiD: true, SinNovedad: true },
          },
          Avisos: {
            Valor: true,
            Detalle: {
              DiasInc: true,
              DiasHca: true,
              DiasTar: true,
              DiasRet: true,
            },
          },
          Extras: true,
        },
        Empleados: [empid],

        Grupos: [],
        Horarios: [],
        Modelos: [],
        Atributos: [],
      };

      filter = JSON.stringify(filter);
      this.$store.dispatch("gestionTiempos/refreshNovelty", filter).then(() => {
        this.newItemRefresh =
          this.$store.state.gestionTiempos.refreshNovelty.item[0];

        this.newArrayRefresh = this.$store.state.gestionTiempos.novedades;

        let indice;
        this.newArrayRefresh.forEach((element, index) => {
          if (element.empId === empid && element.dateNotFormat === date) {
            indice = index;
            element.noveltyEarring = false;
          }
        });
        this.$store.state.gestionTiempos.novedades[indice] =
          this.newItemRefresh;
      });
    },

    //se abre el modal de la accion elegida
    //se ve si tiene items adelante o atras y se disablea si corresponde
    openActions(item) {
      while (item !== undefined) {
        this.selectedRow = item;
        break;
      }

      this.$store.commit(
        "changeSchedule/setSegmentId",
        this.selectedRow.segmId,
      );
      this.$store.commit("gestionTiempos/setDataEmployed", this.selectedRow);

      let signed;
      if (this.selectedRow.firm !== null) {
        if (this.selectedRow.order > Number(sessionStorage.getItem("order"))) {
          signed = true;
          this.$store.commit("gestionTiempos/setHigherOrder", true);
        } else if (
          this.selectedRow.order === Number(sessionStorage.getItem("order"))
        ) {
          signed = true;
          this.$store.commit("gestionTiempos/setHigherOrder", false);
        } else {
          signed = false;
          this.$store.commit("gestionTiempos/setHigherOrder", false);
        }
      } else {
        signed = false;
        this.$store.commit("gestionTiempos/setHigherOrder", false);
      }
      this.$store.commit("gestionTiempos/setSigned", signed);
      this.itemActions = this.selectedRow;
      localStorage.setItem("empId", this.selectedRow.empId);

      this.date = this.selectedRow.date.slice(0, 10).split(/\D/);

      this.date = this.date.reverse().join("-");
      this.$store.commit("gestionTiempos/setDateFromComponents", this.date);
      this.$store.commit("gestionTiempos/setDateToComponents", this.date);
      let items = this.$store.state.gestionTiempos.novedades;

      this.disabledNext = false;
      this.disabledPrevious = false;

      if (parseInt(this.itemActions.movimId, 10) == items[0].movimId) {
        this.disabledPrevious = true;
      }

      if (
        parseInt(this.itemActions.movimId, 10) ==
        items[items.length - 1].movimId
      ) {
        this.disabledNext = true;
      }
    },
    //Va un item atras
    previous() {
      this.showProgressOverlay = true;

      setTimeout(() => {
        this.counter++;
        let items = this.$store.state.gestionTiempos.novedades;
        let itemPrevious;
        for (let i = 0; i < items.length; i++) {
          if (items[i].idController === this.itemActions.idController) {
            itemPrevious = items[i - 1];
          }
        }
        this.$store.commit("changeSchedule/setItemStateDay", {
          empId: itemPrevious.empId,
          date: this.formatDateIso(itemPrevious.date),
        });
        this.$store.dispatch("changeSchedule/getStateDay");

        this.openActions(itemPrevious);
        this.dispatch();
      }, 500);
    },
    //va un item adelante
    next() {
      this.showProgressOverlay = true;
      setTimeout(() => {
        this.counter++;
        let items = this.$store.state.gestionTiempos.novedades;
        let itemNext;
        for (let i = 0; i < items.length; i++) {
          if (items[i].idController === this.itemActions.idController) {
            itemNext = items[i + 1];
          }
        }
        this.$store.commit("changeSchedule/setItemStateDay", {
          empId: itemNext.empId,
          date: this.formatDateIso(itemNext.date),
        });
        this.$store.dispatch("changeSchedule/getStateDay");

        this.openActions(itemNext);
        this.dispatch();
      }, 500);
    },
    //cierra el dialogo de la accion que se estaba ejecutando
    closeDialog() {
      if (this.detailDays && !this.showRegistration) {
        this.showRegistration = true;
        this.showInfo = false;
        this.showGroup = false;
        this.showActions = false;
        this.showAuthorize = false;
        this.showShedule = false;
        this.showTimeSchedule = false;
        this.showChangeSettlement = false;
        this.showAssignCard = false;
        this.showAccessControl = false;
      } else {
        this.detailDays = false;
        this.selectedItem = null;
        this.dispatchFilter();
        registrations.commit("setDialogShow", false);
        this.showInfo = false;
        this.showGroup = false;
        this.showActions = false;
        this.showRegistration = false;
        this.showAuthorize = false;
        this.showShedule = false;
        this.showTimeSchedule = false;
        this.showChangeSettlement = false;
        this.showAssignCard = false;
        this.showAccessControl = false;
      }
    },
    //luego de cerrar el dialogo se llama a el dispatch del filtro para volver a pedir los items
    // por si cambio alguno
    dispatchFilter() {
      let group = this.$store.state.gestionTiempos.saveFilter;
      this.$store.dispatch("gestionTiempos/newController", group);
    },
    //el dispatch de las acciones
    dispatch() {
      if (this.showRegistration) {
        this.dispatechersCommons().then(() => {
          this.showProgressOverlay = false;
          // this.showContainer =true
        });
      } else if (this.showAuthorize) {
        autoriz.commit("setDate", this.date);
        autoriz.dispatch("getAutoriz");
        this.dispatechersCommons().then(() => {
          this.showProgressOverlay = false;
        });
      } else if (this.showAssignCard) {
        this.$store.dispatch("assignCards/getCards");
        this.dispatechersCommons().then(() => {
          this.showProgressOverlay = false;
        });
      } else if (this.showAccessControl) {
        let payload = {
          date: this.itemActions.date
            .slice(0, 10)
            .split(/\D/)
            .reverse()
            .join("-"),
          endDay: this.itemActions.endDay.slice(0, 10),
          startDay: this.itemActions.startDay.slice(0, 10),
        };
        accessControl.commit("setAccessControl", payload);
        accessControl.dispatch("getAccessControl");
        this.dispatechersCommons().then(() => {
          this.showProgressOverlay = false;
        });
      } else if (this.showShedule) {
        this.$store.dispatch("changeSchedule/getEmployedSchedule");
        this.$store.dispatch("changeSchedule/getGroupSchedule");
        this.dispatechersCommons().then(() => {
          this.showProgressOverlay = false;
        });
      } else if (this.showGroup) {
        this.$store.dispatch("changeGroup/getGroupsAssigned");
        this.dispatechersCommons().then(() => {
          this.showProgressOverlay = false;
        });
      } else if (this.showTimeSchedule) {
        changeTimePattern.dispatch("getTimePattern");
        this.dispatechersCommons().then(() => {
          this.showProgressOverlay = false;
        });
      } else if (this.showChangeSettlement) {
        this.$store.dispatch("changeSettlementModel/getModelEmployed");
        this.$store.dispatch("changeSettlementModel/getModelGroup");
        this.dispatechersCommons().then(() => {
          this.showProgressOverlay = false;
        });
      } else if (this.showInfo) {
        resultSettlementHours.commit("setDate", this.date);
        this.dispatechersCommons().then(() => {
          this.showProgressOverlay = false;
        });
      }
    },

    //dispatchers que son comunes en todas las acciones
    async dispatechersCommons() {
      resultSettlementHours.commit("setDate", this.date);
      registrations.commit("setDate", this.date);

      await Promise.all([
        registrations.dispatch("getRegistrations"),
        resultSettlementHours.dispatch("getResults"),
        this.$store.dispatch("changeSchedule/getScheduleElement"),
      ]);
    },
  },
};
</script>

<style>
.border {
  background-color: #1f324a2f;
  border-color: #a5b9d7;
  border-width: 5px;
  border-style: solid;
  border-radius: 25px;
}
.btn-table {
  background-color: #82a1d0;
}
.search {
  max-width: 500px;
}

.container {
  min-width: 100% !important;
}

[estado="normals"] {
  background-color: rgb(14, 176, 14);
  color: white;
  border-radius: 15px 50px 30px;
  font-size: 12px;
  padding: 3px;
}

[estado="avisos"] {
  color: white;
  border-radius: 15px 50px 30px;
  font-size: 12px;
  padding: 3px;
  background-color: rgb(244, 97, 72);
}

[estado="extras"] {
  color: white;
  border-radius: 15px 50px 30px;
  font-size: 12px;
  padding: 3px;
  background-color: rgb(251, 166, 54);
}

[estado="anomalies"] {
  color: white;
  border-radius: 15px 50px 30px;
  font-size: 12px;
  padding: 3px;
  background-color: rgb(54, 169, 251);
}

.clases {
  background-color: black !important;
}

th.text-start {
  background-color: #82a1d0 !important;
}

.table {
  border: 1px solid rgb(156, 151, 151);
}

.td-sub {
  padding: 0px !important;
}

.th-sub-ano {
  border: 1px solid rgb(156, 151, 151) !important;
  background-color: rgb(255, 73, 73);
  color: white;
}

.th-sub-avisos {
  border: 1px solid rgb(156, 151, 151) !important;
  background-color: rgb(253, 200, 28);
  color: white;
}

.th-sub-normals {
  border: 1px solid rgb(156, 151, 151) !important;
  background-color: rgb(137, 178, 244);
  color: white;
}

.th-sub-extras {
  border: 1px solid rgb(156, 151, 151) !important;
  background-color: rgb(79, 197, 66);
  color: white;
}

td {
  text-align: center !important;
}

.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}
.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}
.v-card-dialog {
  background-color: #eaf1f5 !important;
}

.itemhover:hover {
  background-color: rgba(85, 149, 205, 0.097);
  color: #82a1d0 !important;
}

.hovericon {
  color: #82a1d0 !important;
}

.v-list__ {
  max-height: 450px;
  overflow-y: scroll;
  scrollbar-width: unset !important;
}

.loader__title {
  color: white !important;
  display: flex !important;
  justify-content: center !important;
}

.text-start {
  padding: 7px !important;
}

.text-center {
  padding: 5px !important;
}

::v-deep .v-data-table-header th {
  background-color: #82a1d0 !important;
}

::v-deep .v-data-table--fixed-header > .v-data-table__wrapper {
  background: #77dd77;
  overflow-y: scroll;
  scrollbar-width: unset;
}
.v-data-table--fixed-header > .v-data-table__wrapper {
  overflow-y: scroll;
  scrollbar-width: unset;
}
.hover-effect:hover .hover-icon {
  color: #39537a; /* Azul de Vuetify */
  transform: scale(1.2); /* Aumenta ligeramente el tamaño */
  transition: all 0.2s ease-in-out;
}
</style>
